import { render, staticRenderFns } from "./AnexosList.vue?vue&type=template&id=1d2e53ac&scoped=true"
import script from "./AnexosList.vue?vue&type=script&lang=js"
export * from "./AnexosList.vue?vue&type=script&lang=js"
import style0 from "./AnexosList.vue?vue&type=style&index=0&id=1d2e53ac&prod&lang=scss"
import style1 from "./AnexosList.vue?vue&type=style&index=1&id=1d2e53ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2e53ac",
  null
  
)

export default component.exports